import { BusinessProfileActionTypes, RECEIVE_BUSINESS_PROFILE, IBusinessProfileResponse } from "./types";
import { AppThunkAction } from "..";
export const actionCreators = {
    requestBusinessProfile:
        (profileData?: IBusinessProfileResponse): AppThunkAction<BusinessProfileActionTypes> =>
        (dispatch, getState) => {
            dispatch({ type: RECEIVE_BUSINESS_PROFILE, businessProfileData: profileData });
        },
};
